import React, { FC, useState } from 'react';

import Grain from 'components/UI/Grain';
import getStyles from 'helpers/getStyles';
import handleVibrate from 'helpers/handleVibrate';
import Loader from 'components/UI/Loader';

import { CardSchema, ECardLayoutOptions } from 'constants/graphqlTypes';
import { TEST_CARD_FIRST_UP_IMAGE, TEST_CARD_COMMON_IMAGE, getCardImageId } from 'constants/aqa/card';
import { StyledBody, StyledLink, StyledLoader, StyledSpace } from './styled';

import Content from './Content';
import Image from './Image';
import { getTransformedGradient } from './helpers';

interface BodyProps {
  card: CardSchema;
  isFirstUp?: boolean;
  dataTestId?: string;
  bodyRef?: React.Ref<HTMLDivElement>;
  imageRef?: React.Ref<HTMLDivElement>;
  imageAnimationProgress?: number;
  isImageAnimating?: boolean;
  interpolatedRotation?: number;
  interpolatedScale?: number;
  onImageLoad?: () => void;
}

const Body: FC<BodyProps> = ({
  card,
  isFirstUp,
  dataTestId,
  bodyRef,
  imageRef,
  imageAnimationProgress = 0,
  isImageAnimating = false,
  interpolatedRotation = 0,
  interpolatedScale = 1,
  onImageLoad,
}) => {
  const [isVertical, setIsVertical] = useState(false);
  const { cardStyle, primarySourceUrl, displayBackgroundColor } = card;
  const { bgColor, layout } = getStyles(cardStyle);
  const sourceUrl = primarySourceUrl ?? card?.externalSources?.items?.[0]?.sourceUrl;

  const isBorderlessCard = layout === ECardLayoutOptions.Borderless;
  return (
    <StyledLink
      className="card"
      href={sourceUrl ?? '#'}
      onClick={handleVibrate}
      target="_blank"
      rel="noopener noreferrer"
    >
      <StyledBody
        ref={bodyRef}
        className="card-body"
        bg={isBorderlessCard ? getTransformedGradient(bgColor) : bgColor}
        isReverse={isBorderlessCard}
      >
        <Grain />
        <Content
          isImageVertical={isVertical}
          dataTestId={dataTestId ?? (isFirstUp ? TEST_CARD_FIRST_UP_IMAGE : TEST_CARD_COMMON_IMAGE)}
          bigTitle={isFirstUp}
          card={card}
        />
        <Image
          setIsVertical={setIsVertical}
          dataTestId={getCardImageId(dataTestId ?? (isFirstUp ? TEST_CARD_FIRST_UP_IMAGE : TEST_CARD_COMMON_IMAGE))}
          card={card}
          imageRef={imageRef}
          imageAnimationProgress={imageAnimationProgress}
          isImageAnimating={isImageAnimating}
          interpolatedRotation={interpolatedRotation}
          interpolatedScale={interpolatedScale}
          onImageLoad={onImageLoad}
        />
        <StyledLoader className="card-image-loader">
          <Loader />
        </StyledLoader>
        {layout === ECardLayoutOptions.Plain && <StyledSpace isFirstUp={isFirstUp} />}
      </StyledBody>
    </StyledLink>
  );
};

export default Body;
